module.exports = __webpack_public_path__ + "static/media/branding-logo.b35d8964.png";